export default __webpack_public_path__ + "static/media/Slide1.f2f0bb88.png";